import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

type Constructor<T> = new (...args: any[]) => T;

interface IWithSubscription {
  subs: Subscription;
}

export function WithSubscription<T extends Constructor<any>>(Base: T = class {} as any) {
  return class extends Base implements IWithSubscription, OnDestroy {
    public subs: Subscription = new Subscription();

    constructor(...args: any[]) {
      super(...args);
    }

    public ngOnDestroy(): void {
      if (super.ngOnDestroy) {
        super.ngOnDestroy();
      }
      this.subs.unsubscribe();
    }
  };
}
